module.exports = __webpack_public_path__ + "img/w_big.54fac3fc.svg";